module.exports = require('./helpers/bundle-url').getBundleURL('13x6K') + "logo-dark.eefe0b7f.svg";